import {
  BASE_HREF,
  COOKIE_ACM_ID,
  COOKIE_PARTICIPANT_AUTH,
  COOKIE_PORTAL_EMAIL,
  STUDY_ID,
  TRIAGE_API_VERSION,
  TRIAGE_ENDPOINT,
} from '../constants';
import api, { getPreviewToken } from '../services';

import { RSAA } from 'redux-api-middleware';
import _ from 'lodash';
import { getUrlParams } from '../utils';

const baseURL = `${TRIAGE_ENDPOINT}/api/${TRIAGE_API_VERSION}/studies/${STUDY_ID}/`;

const v3URL = `${TRIAGE_ENDPOINT}/api/v3/`;

const REQUEST = 'USER/REQUEST';
const FAILURE = 'ERRORS/ADD';
const SUCCESS = {
  type: 'USER/LOGIN',
  payload: (action, state, res) => res.json().then(newres => newres),
};

const authHeader = auth_token => ({
  'Content-Type': 'application/json',
  'Participant-Auth-Token': auth_token,
  'Preview-Token': getPreviewToken(),
});

export const loginUser = (payload, enrollment_identifier, auth_token) => {
  return {
    [RSAA]: {
      endpoint: baseURL + `enrollments/sign_in`,
      method: `POST`,
      body: JSON.stringify(payload),
      headers: authHeader(auth_token),
      types: [REQUEST, SUCCESS, FAILURE],
    },
  };
};

export const authenticateUser = (
  payload,
  enrollment_identifier,
  auth_token,
) => ({
  [RSAA]: {
    endpoint: v3URL + `enrollments/${enrollment_identifier}/reauthenticate`,
    method: `POST`,
    body: JSON.stringify(payload),
    headers: authHeader(auth_token),
    types: [REQUEST, SUCCESS, FAILURE],
  },
});

export const updateUser = (payload, enrollment_identifier, auth_token) => ({
  [RSAA]: {
    endpoint: baseURL + `enrollments/${enrollment_identifier}`,
    method: `PUT`,
    body: JSON.stringify({
      user_data: { ...payload },
    }),
    headers: authHeader(auth_token),
    types: [REQUEST, SUCCESS, FAILURE],
  },
});

export const createUser = payload => ({
  [RSAA]: {
    endpoint: baseURL + `enrollments`,
    method: `POST`,
    body: JSON.stringify({ user_data: payload }),
    headers: authHeader(''),
    types: [REQUEST, SUCCESS, FAILURE],
    credentials: `same-origin`,
  },
});

export const getUser = (enrollment_identifier, auth_token) => ({
  [RSAA]: {
    endpoint: baseURL + `enrollments/${enrollment_identifier}`,
    method: `GET`,
    headers: authHeader(auth_token),
    types: [REQUEST, SUCCESS, FAILURE],
  },
});

export const deleteOldestMessage = (enrollment_identifier, auth_token) => ({
  [RSAA]: {
    endpoint:
      baseURL + `enrollments/${enrollment_identifier}/delete_oldest_message`,
    method: `PUT`,
    headers: authHeader(auth_token),
    types: [REQUEST, SUCCESS, FAILURE],
  },
});

export const getSurvey = slug => {
  return {
    [RSAA]: {
      endpoint:
        v3URL +
        `surveys/${slug}?enrollment_identifier=${api.cookie.get(
          'enrollment_identifier',
        )}&occurrence=${api.cookie.get('occurrence')}`,
      method: 'GET',
      types: [
        'USER/REQUEST',
        {
          type: 'USER/LOGIN',
          payload: (action, state, res) =>
            res.json().then(newres => ({
              nodes: [newres],
              layout: newres.layout,
            })),
        },
        'USER/FAILURE',
      ],
    },
  };
};

export const submitSurvey = (contributions, slug) => {
  const params = getUrlParams(window.location.search);

  let scoped_auth_token = api.cookie.get('auth_token');
  let enrollment_identifier = api.cookie.get('enrollment_identifier');
  let occurrence = api.cookie.get('occurrence');

  // There may be some cases where cookies are not saved
  // possibility of this is an email client that doesn't support them
  // since the URl _should_ still contain these parameters, it's safe to opt to use them
  // if a parameter is missing and data is still submitted, the user
  // receives a message saying the contribution is nolonger available
  if (_.has(params, `auth_token`)) {
    scoped_auth_token = params.auth_token;
  }

  if (_.has(params, `enrollment_identifier`)) {
    enrollment_identifier = params.enrollment_identifier;
  }

  if (_.has(params, `occurrence`)) {
    occurrence = params.occurrence;
  }

  return {
    [RSAA]: {
      endpoint: v3URL + `surveys/${slug}/answers`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Scoped-Auth-Token': scoped_auth_token,
      },
      body: JSON.stringify({
        enrollment_identifier,
        occurrence,
        contributions,
      }),
      types: [
        'USER/REQUEST',
        {
          type: 'USER/LOGIN',
          payload: (action, state, res) =>
            res.json().then(newres => ({
              nodes: [newres],
            })),
        },
        {
          type: 'USER/FAILURE',
          payload: (action, state, res) => res.json().then(newres => newres),
        },
      ],
    },
  };
};

export const logoutUser = () => {
  api.localStorage.set({});
  api.cookie.remove(COOKIE_PARTICIPANT_AUTH);
  api.cookie.remove(COOKIE_PORTAL_EMAIL, { domain: '.myachievement.com' });
  api.cookie.remove(COOKIE_ACM_ID, { domain: '.myachievement.com' });
  window.location.href = BASE_HREF;
  return { type: 'USER/LOGOUT' };
};

export const establishUser = payload => ({ type: `USER/LOGIN`, payload });

export const updateAcmInfo = payload => ({ type: 'USER/UPDATE_ACM', payload });



// WEBPACK FOOTER //
// ./src/actions/participant_actions.js